/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext } from 'react'

import { Container, Button } from 'react-bootstrap'
import { Icon } from '@material-ui/core';
import { useHistory, useParams } from "react-router-dom";
// import { Cookies } from "react-cookie"
import Swal from 'sweetalert2';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';

// import Menu from '@material-ui/core/Menu';
// import MenuItem from '@material-ui/core/MenuItem';
// import MoreVertIcon from '@material-ui/icons/MoreVert';
// import EditIcon from '@material-ui/icons/Edit';
// import SearchIcon from '@material-ui/icons/Search';

import { reqRoleById } from '../service'
import ic_role_manage from '../images/ic_role_manage.svg'

import { Row, Col, Card, ListGroup, Media, Accordion, Badge } from 'react-bootstrap'
import DeleteIcon from '@material-ui/icons/Delete'
// import BorderColorIcon from '@material-ui/icons/BorderColor';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
// import SearchIcon from '@material-ui/icons/Search'


import manage_user from '../images/ic_manage_user.svg'

import EditName from "./modal/EditName"
// import AddMember from "./modal/AddMember"
// import StepRoleUpdate from "./StepRoleUpdate"
import AddMemberToRole from "./AddMemberToRole"

import Header from './layout/Header'

import AddApplication from './modal/AddApplication';
import EditApplication from './modal/EditApplication';
import { deleteAppGroup, deleteGroup, reqAppList, reqAddAppToGroup, deleteUserGroup } from '../service/service';

const RoleDetail = () => {
    let { id } = useParams();
    // const [role, setRole] = useState(null)
    // const [textSearch, settextSearch] = useState("")
    let history = useHistory();
    const [currentStep, setCurrentStep] = useState(1);
    const [appList, setAppList] = useState([])

    const [apps, setApps] = useState([])
    const [permissionSetting, setPermissionSetting] = useState([])

    const handleSetApp = (param, permission) => {
        setApps([...apps, param])
        setPermissionSetting([...permissionSetting, permission])

        const a = {
            "route": param,
            permission: permission.length === 0 ? null : permission
        }
        const route = {
            app: a,
            group_id: state.groupID,
        }
        reqAddAppToGroup(route).then(res=>{
            RequestRoleDetail()
        }).catch(err=>{
            console.log(err)
        })
    }
    const [errors] = useState({});
    const [state, setState] = React.useState({
        roleName: '',
        departmentName: 'Department Name',
        permissionSetting: [],
        users: [],
        apps: [],
        groupID: id,
    });

    function handleClickBack() {
        history.push("/");
        history.go()
    }
    function RequestRoleDetail() {

        
        reqRoleById(id).then(res => {
            // console.log(res)
            // setRole(res.result)
            setState({ ...state, users: res.result.users, apps: res.result.apps, roleName: res.result.name });
            // setState({ ...state, apps: res.result.apps });
        }).catch(err => {
            console.log(err)
        })
    }

    // useEffect(() => {
    //     RequestRoleDetail()
    // }, [])
    useEffect(() => {

        function reqApps() {
            reqAppList().then(res => {
                res.result.sort(function(a, b){
                    if(a.name < b.name) { return -1; }
                    if(a.name > b.name) { return 1; }
                    return 0;
                })
                setAppList(res.result)
                // if (res.result.length > 0) {
                //     setAppValue(res.result[0].id)
                // }
            }).catch(_err => {

            })
        }
        RequestRoleDetail()
        reqApps()
        // requestPermissions()
    }, [])



    // function requestSerchUserByText() {
    //     console.log('hi5')
    //     authSign().then(res => {
    //         console.log(res)
    //         if (res.token !== undefined) {
    //             const cookies = new Cookies()
    //             cookies.set('token', res.token)
    //             cookies.set('tmp', res.tmp)
    //             const params = {
    //                 "work": "SEARCH_USERS_BY_TEXT",
    //                 "item_per_request": 15,
    //                 "current_item_amount": 0,
    //                 "search_value": textSearch
    //             }
    //             console.log(params)
    //             reqSerchUserByText(params).then(res => {
    //                 console.log(res)
    //                 setUsersSearch(res.result)
    //             }).catch(err => {
    //                 console.log(err)
    //             })
    //         }
    //     }).catch(err => {
    //         console.log(err)
    //     })
    // }
    // console.log(role)
    // function _Confirm(event) {

    // }
    // function goCancel() {
    //     history.push({
    //         pathname: '/',
    //         search: '',
    //     })
    //     history.go(0)
    // }

    function nextButton(event) {
        return (
            <>
                {/* <Button variant="light" className="px-5 border mr-2" onClick={goCancel}>Cancel</Button>
                <Button variant="primary" className="px-5" type="submit"onClick={e => setCurrentStep(1)}>Confirm</Button> */}
            </>
        );
    }


    function previousButton() {

        return (
            <>
                <Button onClick={e => setCurrentStep(1)} variant="link" className="mt-3 p-0">
                    <p className="text-muted" style={{ fontSize: "14px" }} >
                        <Icon style={{ paddingTop: "6px" }}>keyboard_arrow_left</Icon>Back</p>
                </Button>
                <h4 className="mb-4">Add Member To Role</h4>
            </>
        );
    }
    const handleDeleteEmp = emp => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You want to be able to delete this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                const data = {
                    group_id: state.groupID,
                    employeeid: emp.employeeid
                }
                deleteUserGroup(data).then(res => {
                    RequestRoleDetail()
                }).catch(err => {
                    console.log(err)
                })
            }
        })

    }
    const handleDeleteGroup = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You want to be able to delete group!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                deleteGroup(state.groupID).then(res => {
                    if (res.code === 200) {
                        history.push('/')
                        history.go(0)
                    }
                }).catch(err => {
                    console.log(err)
                })
            }
        })
        // setAnchorEl(null);
    };
    const deleteApp = (e) => {
        // console.log(e)
        Swal.fire({
            title: 'Are you sure?',
            text: "You want to be able to delete this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                const data = {
                    group_id: state.groupID,
                    route_id: e.route.id
                }
                deleteAppGroup(data).then(res => {
                    // console.log(res)
                    RequestRoleDetail()
                }).catch(err => {
                    console.log(err)
                })
            }
        })
        // setAnchorEl(null);
    };
    function CustomToggle({ children, eventKey, callback, activeClass }) {

        const currentEventKey = useContext(AccordionContext);

        const decoratedOnClick = useAccordionToggle(
            eventKey,
            () => callback && callback(eventKey),
        );

        const isCurrentEventKey = currentEventKey === eventKey;
        return (
            <div onClick={decoratedOnClick} className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    {children}
                </div>
                {isCurrentEventKey ? <ExpandLessIcon color="light" style={{ width: "18px", height: "18px" }} /> : <ExpandMoreIcon color="light" style={{ width: "18px", height: "18px" }} />}


            </div>
        );
    }

    return (
        <>
            <Header logo={ic_role_manage} navbarRight={nextButton} />
            {currentStep === 1 ? <Container role="main" className="main-content bg-whiht">

                <div className='row flex-xl-nowrap'>
                    <div className='col-md-12'>
                        <div className='flex-column align-items-center justify-content-between'>
                            <Button onClick={handleClickBack} variant="link" className="mt-3 p-0">
                                <p className="text-muted" style={{ fontSize: "14px" }} >
                                    <Icon style={{ paddingTop: "6px" }}>keyboard_arrow_left</Icon>Home</p>
                            </Button>
                            <h4 className="mb-4">Edit Role</h4>
                        </div>
                    </div>
                </div>
                <Row>
                    <Col xs={8}>
                        <Card className="shadow-sm">
                            <Card.Header as="h5" className="bg-white border-0">

                                <div className="d-flex flex-column">

                                    <div className="d-flex  my-2">
                                        <div className="flex-fill flex-grow-1 mr-2">
                                            <input type="text" className="form-control" id="inlineFormInputGroup" placeholder="" />
                                        </div>
                                        <div className='mx-2'>
                                            {/* <AddMember /> */}
                                            <Button variant="outline-light" className="text-dark border" onClick={e => setCurrentStep(2)}>Add Member</Button>
                                            {/* <Button variant="outline-light" className="border">Add Member</Button> */}
                                        </div>
                                    </div>
                                    <div className="d-flex flex-row align-items-center  my-2 text-muted">
                                        <img src={manage_user} alt="" className="mr-2" />
                                        <h6 className="mb-0">{state.users ? state.users.length > 0 ? state.users.length : 0 : 0} Members</h6>
                                    </div>
                                </div>
                            </Card.Header>
                            <Card.Body >
                                <ListGroup variant="flush">
                                    {state.users ?
                                        state.users.length > 0 ? (
                                            state.users.map((user, i) => {
                                                return (
                                                    <ListGroup.Item key={i} className="custom-item">
                                                        <Media className="float-left">
                                                            {/* <Image className="mr-2" style={{ width: 40, height: 40 }} roundedCircle src={user.picture}
                                                                        onError={(e) => { e.target.onerror = null; e.target.src = iconavatar }} /> */}

                                                            <Media.Body>
                                                                <p className="mb-0">{user.firstname}  {user.lastname}, {user.employeeid}</p>
                                                                {/* <p></p> */}
                                                            </Media.Body>
                                                        </Media>
                                                        <Button style={{ padding: "2px 6px" }} variant="light" className="float-right rounded-circle" onClick={() => handleDeleteEmp(user)}>
                                                            <DeleteIcon color="disabled" style={{ width: "18px", height: "24px" }} />
                                                        </Button>

                                                    </ListGroup.Item>
                                                )
                                            })
                                        ) : null : null
                                    }

                                </ListGroup>
                            </Card.Body>
                            {/* <Card.Footer className="text-muted bg-white">
                                <img src={manage_user} alt="" className="mr-2" />{state.users ? state.users.length > 0 ? state.users.length : 0 : 0} Members
                            </Card.Footer> */}
                        </Card>
                    </Col>
                    <Col xs={4}>
                        <Card>
                            <Card.Header className="bg-white">
                                <div className="d-flex justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <img src={ic_role_manage} alt="" width="20" className="mr-2" />
                                        <h6 className='mb-0'>{state.roleName}</h6>
                                    </div>
                                    <EditName state={state} setName={setState} />

                                </div>
                                {/* {props.nextEdit()} */}
                            </Card.Header>
                            <Card.Body>
                                <h6 className="mb-2 text-black-50">Application Access</h6>
                                {state.apps ?
                                    state.apps.length > 0 ? (
                                        Array.from(state.apps).map((app, i) => (
                                            <Card className="my-2" key={i}>
                                                <Card.Header className="bg-white p-1 px-2">
                                                    <div className="d-flex justify-content-between">
                                                        <div className="d-flex align-items-center">
                                                            <h6 className='mb-0'>{app.route.name}</h6>
                                                        </div>
                                                        <div className="d-flex justify-content-end">
                                                            <EditApplication appList={appList} apps={app} setApps={handleSetApp}></EditApplication>
                                                            <Button className="px-1" variant="link" onClick={() => deleteApp(app)}>
                                                                <DeleteIcon color="disabled" style={{ width: "18px", height: "24px" }} />
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </Card.Header>
                                                <Accordion>
                                                    <Card className="border-0 hide-feature">
                                                        <Card.Header className="bg-white px-2 border-0">
                                                            <CustomToggle eventKey="0"><p className='mb-0'>Permission Access<Badge className="border ml-1" variant="light">{permissionSetting[i]? permissionSetting[i]?.filter((r) => r.value === true).length: 0 }</Badge></p></CustomToggle>
                                                        </Card.Header>
                                                        <Accordion.Collapse eventKey="0">
                                                            <Card.Body className='px-2 py-2'>
                                                                {permissionSetting[i]?.filter((r) => r.value === true)?.map((p, i) => (
                                                                    <p className='mb-0' key={i}>{ p.name }</p>
                                                                ))}
                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                </Accordion>
                                            </Card>

                                        ))
                                    ) : null : null}
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <div className='d-flex justify-content-start my-3'>
                                            <AddApplication className="border btn btn-outlined" appList={appList} apps={apps} setApps={handleSetApp}></AddApplication>
                                        </div>
                                    </div>
                                </div>
                            </Card.Body>

                        </Card>

                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <div className="d-flex justify-content-end mb-4">
                            <Button className="my-3 border mx-1 text-muted" variant="outlined" onClick={handleDeleteGroup}>Delete Group</Button>
                            {/* <Button className="my-3 mx-1" variant="primary">Save</Button> */}
                        </div>
                    </Col>
                </Row>
            </Container> : <AddMemberToRole
                currentStep={currentStep}
                data={state}
                errors={errors}
                handleChange={setState}
                nextButton={nextButton}
                previousButton={previousButton}
                addUser={RequestRoleDetail}
            ></AddMemberToRole>}

            {/* <Container role="main" className="main-content mb-5" >
                <StepRoleDatail
                    currentStep={currentStep}
                    data={state}
                    errors={errors}
                    handleChange={setState}
                    nextButton={nextButton}
                    nextEdit={nextEdit}
                    nextAddmem={nextAddmem}
                    previousButton={previousButton}
                    deleteUser={RequestRoleDetail}
                ></StepRoleDatail>
                <StepRoleUpdate
                    currentStep={currentStep}
                    data={state}
                    errors={errors}
                    handleChange={setState}
                    nextButton={nextButton}
                    previousButton={previousButton}

                />
                <AddMemberToRole
                    currentStep={currentStep}
                    data={state}
                    errors={errors}
                    handleChange={setState}
                    nextButton={nextButton}
                    previousButton={previousButton}
                    addUser={RequestRoleDetail}
                ></AddMemberToRole>


            </Container> */}

        </>
    )


}

export default RoleDetail